/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { generateIteratorKey as keygen } from '../../utils/helpers';
import * as consts from '../../const';
import { participants } from '../../constants/localUrls';

const columns = {
  sponsor: consts.SPONSOR,
  study: consts.STUDY,
  protocol: consts.PROTOCOL_NO,
  action: consts.ACTIONS
};

const createRows = (response) => {
  let rows = [];

  if (!StudiesService.hasStudies(response)) {
    return;
  }

  for (let studyData of response.data.studies.data) {
    let url = participants(studyData.study.gid);
    let link = (
      <Link
        className="link"
        to={{
          pathname: url,
          state: {
            forBreadcrumb: {
              studyGid: studyData.study.gid,
              studyName: studyData.study.name
            }
          }
        }}
      >
        View
      </Link>
    );

    let row = (
      <Row {...keygen()} className="study-row">
        <Col className="study-col" xs={4}>
          {studyData.sponsorName}
        </Col>
        <Col className="study-col" xs={3}>
          {studyData.study.name}
        </Col>
        <Col className="study-col" xs={2}>
          {studyData.study.protocolNumber}
        </Col>
        <Col className="study-col" xs={1}>
          {link}
        </Col>
      </Row>
    );
    rows.push(row);
  }
  return rows;
};

class StudiesService {
  static createGrid(data) {
    let rowData = createRows(data);
    return (
      <Grid fluid id="studies-list" className="tc-grid">
        <Row className="studies-header tc-grid-header">
          <Col className="study-col" xs={4}>
            {columns.sponsor}
          </Col>
          <Col className="study-col" xs={3}>
            {columns.study}
          </Col>
          <Col className="study-col" xs={2}>
            {columns.protocol}
          </Col>
          <Col className="study-col" xs={1}>
            {columns.action}
          </Col>
        </Row>
        {rowData}
      </Grid>
    );
  }

  static hasStudies(rows) {
    if (rows && rows.data && rows.data.studies && rows.data.studies.data) {
      return true;
    }
    return false;
  }
}

export default StudiesService;
